export default "__VITE_ASSET__qbhvqHiY__"